export default __webpack_public_path__ + "static/media/wallet.10a52c11.png";